// Imports
    import { Link } from "react-router-dom";
    // Firebase
    import { deleteOrder } from "../firebase/FirebaseClient";
    // Icons
    import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
    import { faEye, faTrashCan } from "@fortawesome/free-solid-svg-icons"




// rafce

const OrderCard = ({order}) => {

  // Component
  return (
    <>
      <li className="order">
        <div className='order-info'>
          <p>{order.buyer.name}</p>
          <p>{order.buyer.phone}</p>
          <span>$ {order.total.toFixed(2)}</span>
          <div>
            <Link to={`/admin/ordenes/${order.id}`}><FontAwesomeIcon icon={ faEye } /></Link>
            <button onClick={() => deleteOrder(order.id)}><FontAwesomeIcon icon={ faTrashCan } /></button>
          </div>  
        </div>
        <div className='order-items'>
            {
              order.cart.map( i =>
                <div key={i.id}>
                  <p>{i.name}</p>
                  <span>{i.qty}</span>
                  <span>${i.price.toFixed(2)} c/u</span>
                </div>
              )
            }
        </div>
      </li>
    </>
  )
}

export default OrderCard